import React, { useEffect, useState } from 'react';
import { getLoginCount } from '../api';

function LoginModal({
  showAuthModal,
  authMode,
  setAuthMode,
  authForm,
  setAuthForm,
  status,
  onAuthSubmit,
  onClose,
}) {
  const [loginCount, setLoginCount] = useState(null);

  useEffect(() => {
    if (!showAuthModal) return undefined;
    let cancelled = false;
    getLoginCount()
      .then((data) => {
        if (!cancelled && typeof data.loginCount === 'number') {
          setLoginCount(data.loginCount);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [showAuthModal]);

  if (!showAuthModal) {
    return null;
  }

  const isSignup = authMode === 'signup';

  return (
    <div className="modal-overlay">
      {showAuthModal && (
        <div className="modal-card">
          {typeof loginCount === 'number' && (
            <span className="login-count-badge" title="Tracked logins">
              {loginCount.toLocaleString()}
            </span>
          )}
          {onClose && (
            <button
              type="button"
              className="modal-close"
              onClick={onClose}
              aria-label="Close"
              disabled={status.authLoading}
            >
              ×
            </button>
          )}
          <h2>{isSignup ? 'Create an account' : 'Welcome back'}</h2>
          <p>
            {isSignup
              ? 'Sign up to start practicing and save your progress.'
              : 'Log in to keep your graded answers and skill progress.'}
          </p>
          <div className="auth-tabs">
            <button
              type="button"
              className={`ghost ${authMode === 'login' ? 'tab-active' : ''}`}
              onClick={() => setAuthMode('login')}
            >
              Login
            </button>
            <button
              type="button"
              className={`ghost ${isSignup ? 'tab-active' : ''}`}
              onClick={() => setAuthMode('signup')}
            >
              Sign up
            </button>
          </div>
          <form
            className="stack"
            onSubmit={(e) => {
              e.preventDefault();
              onAuthSubmit();
            }}
          >
            <div className="field">
              <label>Username</label>
              <input
                type="text"
                autoComplete="username"
                value={authForm.email}
                onChange={(e) => setAuthForm((prev) => ({ ...prev, email: e.target.value }))}
                placeholder="Enter username"
                disabled={status.authLoading}
              />
            </div>
            <div className="field">
              <label>Password</label>
              <input
                type="password"
                autoComplete={isSignup ? 'new-password' : 'current-password'}
                value={authForm.password}
                onChange={(e) => setAuthForm((prev) => ({ ...prev, password: e.target.value }))}
                placeholder="Enter password"
                disabled={status.authLoading}
              />
            </div>
            <button type="submit" className="primary full-width" disabled={status.authLoading}>
              {status.authLoading ? 'Please wait...' : isSignup ? 'Sign up' : 'Login'}
            </button>
            {status.error && <div className="error">{status.error}</div>}
          </form>
        </div>
      )}
    </div>
  );
}

export default LoginModal;
